import { PartialType } from '../../../utils';
import { CreateInsuranceDetailDto } from './create-insurance-detail.dto';
export class UpdateInsuranceDetailDto extends PartialType(CreateInsuranceDetailDto) {
}
